export function getByTitle (list, keyword) {
    const search = keyword.trim().toLowerCase();
    if (!search.length) return list;
    return list.filter(item => item.descripcion.toLowerCase().indexOf(search) > -1);
}
export function getByPrice (list, precio) {
    if (precio === 0) return list;
    return list.filter(item => item.price >= precio[0] && item.price <= precio[1]);
}
export default {getByTitle, getByPrice}